<div class="card">
    <div class="card-header">
        <label>Upload Logo</label>
    </div>
    <div class="card-body">
        <div class="d-flex align-items-center mb-3">

            <label for="fileUploader" class="btn btn-info btn-sm add-btn mr-3">
                <i class="fa fa-upload" aria-hidden="true"></i> Upload
            </label>

            <div class="form-check d-flex align-items-center">
                <input type="checkbox" class="form-check-input me-2" id="displayLogoOnReceipt" name="displayLogoOnReceipt"
                    title="This logo will appear on the customer's receipt for vTerminal payments"
                    [checked]="displayLogoOnReceipt" (change)="onDisplayLogoChange($event)" />
                <label class="form-check-label" for="displayLogoOnReceipt"
                    title="This logo will appear on the customer's receipt for vTerminal payments">
                    display logo on receipt?
                </label>
            </div>
        </div>

        <input
            id="fileUploader"
            name="fileUpload"
            accept=".jpg, .jpeg, .png"
            multiple="false"
            type="file"
            (change)="fileUpload($event)"
            class="hide-no-dimensions"
        />
        <span #preview id="preview">
            <img *ngIf="image" src="{{ image }}" />
            <span *ngIf="!image">{{ NO_SELECTED_IMAGE_MSG }}</span>
        </span>
        <canvas #canvas class="hide-no-dimensions"></canvas>
    </div>
</div>
